// components/Header.jsx
import React from "react";
import { Typography } from "@mui/material";

const Header = ({ text, styles }) => {
  return (
    <Typography
      variant={styles.header?.fontSize || "h5"}
      gutterBottom
      sx={{
        color: styles.header?.color || "inherit",
        fontFamily: styles.header?.fontFamily || "inherit",
      }}
    >
      {text}
    </Typography>
  );
};

export default Header;
